const modalAtts = 'height=320,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0';

const shareButtonActions = () => {
    $('.twitter-share').on('click', () => {
		const $url = $(this).attr('data-url');
		const $title = $(this).attr('data-title');
		window.open(
			`http://twitter.com/intent/tweet?text=${$title} ${$url}`,
			'twitterWindow',
			modalAtts,
		);
		return false;
    });

    $('.pinterest-share').on('click', () => {
		const $url = $(this).attr('data-url');
		const $title = $(this).attr('data-title');
		const $image = $(this).attr('data-image');
		window.open(
			`http://pinterest.com/pin/create/button/?url=${$url}&media=${$image}&description=${$title}`,
			'twitterWindow',
			modalAtts,
		);
		return false;
    });

    $('.facebook-share').on('click', () => {
		const $url = $(this).attr('data-url');
		window.open(
			`https://www.facebook.com/sharer/sharer.php?u=${$url}`,
			'facebookWindow',
			modalAtts,
		);
		return false;
    });

    $('.googleplus-share').on('click', () => {
		const $url = $(this).attr('data-url');
		window.open(
			`https://plus.google.com/share?url=${$url}`,
			'googlePlusWindow',
			modalAtts,
		);
		return false;
    });

    $('.linkedin-share').on('click', (event) => {
		const $that = $(event.currentTarget);
		const $url = $that.attr('data-url');
		const $title = $that.attr('data-title');
		const $desc = $that.attr('data-desc');
		window.open(
			`http://www.linkedin.com/shareArticle?mini=true&url=${$url}&title=${$title}&summary=${$desc}`,
			'linkedInWindow',
			modalAtts,
		);
		return false;
    });

    return true;
};

const dpspFloatingSidebar = () => {
	const $socialFloatingBar = $('#dpsp-floating-sidebar');
    const $socialMobilePlaceholder = $('.mobile-social');

    if ($socialFloatingBar.length && $socialMobilePlaceholder.length) {
		const $clonedSocial = $socialFloatingBar.clone();
		$socialMobilePlaceholder.append($clonedSocial);
    }
};

const navItemModal = () => {
	const modals = document.querySelector('.js-trigger-nav-item-modal');

	// open the modal.
	modals.addEventListener('click', (event) => {
		event.preventDefault();
		const parent = event.target.closest('li');
		parent.classList.add('vtc-modal-open');
	});

	// close the modal.
	document.addEventListener('click', (event) => {
		if (
			event.target.matches('.close-modal')
			|| !event.target.closest('.js-trigger-nav-item-modal')
		) {
			modals.classList.remove('vtc-modal-open');
		}
	}, false);
};

const Social = () => {
	shareButtonActions();
	dpspFloatingSidebar();
	navItemModal();
};

export default Social();
